/* [deskv3-4oct] Desktop-only product page scripts, moved out of sections/samedi-product.liquid because that
   section hit Shopify's 256 KB template limit. Each block guards itself with matchMedia('(min-width: 1001px)'). */

/* [deskv2-4oct] desktop "Pairs well with": three across, arrows reach the fourth. Phones untouched (min-width:990 only). */
(function(){
  if(!window.matchMedia || !window.matchMedia('(min-width: 1001px)').matches) return;
  /* align the section to the measured product row: gallery left edge to buy column right edge */
  function align(){
    var sec=document.querySelector('.pdp-sec.sec-div'), g=document.querySelector('.pdp .gallery'), b=document.querySelector('.pdp .buybox');
    if(!sec||!g||!b) return;
    sec.style.removeProperty('left'); sec.style.removeProperty('width');
    var gl=g.getBoundingClientRect().left, br=b.getBoundingClientRect().right, sl=sec.getBoundingClientRect().left;
    sec.style.setProperty('width', Math.round(br-gl)+'px', 'important');
    sec.style.setProperty('left', Math.round(gl-sl)+'px', 'important');
  }
  function mount(){
    align();
    window.addEventListener('resize', function(){
      if(window.matchMedia('(min-width: 1001px)').matches) align();
      else { var s=document.querySelector('.pdp-sec.sec-div'); if(s){ s.style.removeProperty('left'); s.style.removeProperty('width'); } }
    }, {passive:true});
    var sec=document.querySelector('.pdp-sec.sec-div'), rail=sec&&sec.querySelector('.grid-3'), head=sec&&sec.querySelector('.sec-head');
    if(!rail||!head||head.querySelector('.c2rail')) return;
    if(rail.children.length<=3) return;
    var box=document.createElement('div'); box.className='c2rail';
    var mk=function(dir,label,path){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label',label);
      b.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="'+path+'"/></svg>';
      b.addEventListener('click',function(){var card=rail.children[0].getBoundingClientRect().width+24; rail.scrollBy({left:dir*card,behavior:'smooth'});});return b;};
    var prev=mk(-1,'Previous products','M15 6l-6 6 6 6'), next=mk(1,'Next products','M9 6l6 6-6 6');
    box.appendChild(prev); box.appendChild(next); head.appendChild(box);
    var sync=function(){prev.disabled=rail.scrollLeft<=2; next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;};
    rail.addEventListener('scroll',sync,{passive:true}); sync();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',mount); else mount();
  /* the recommendations section can be re-rendered after first paint, which drops the arrows and the alignment;
     attach again once the page has loaded (mount() never adds a second set) */
  window.addEventListener('load', function(){ mount(); setTimeout(mount, 1200); });
})();


/* [deskv2-4oct r6] desktop size buttons: "Choose your size" label, and each button names its length
   ("S · 18cm"), read from the button's own value. Phones keep the dropdown and "Size". */
(function(){
  if(!window.matchMedia || !window.matchMedia('(min-width: 1001px)').matches) return;
  function run(){
    document.querySelectorAll('.pdp .opt-row--chips').forEach(function(row){
      var l=row.querySelector('.opt-label'); if(l && !l.dataset.c2){ var v=l.querySelector('.opt-val'); l.textContent='Choose your size'; if(v) l.appendChild(v); l.dataset.c2='1'; }
      /* chip lengths are drawn by CSS from data-val ([deskv2-4oct r6b]); a theme script rewrites chip text */
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
})();


/* [deskv3-4oct] desktop buy column per the owner's mockup: size label shows the chosen length, "Size Guide",
   "Also available", and whole-pound prices (pence kept when real). Desktop only; phones untouched. */
(function(){
  if(!window.matchMedia || !window.matchMedia('(min-width: 1001px)').matches) return;
  function label(){
    document.querySelectorAll('.pdp .opt-row--chips').forEach(function(row){
      var l=row.querySelector('.opt-label'), sel=row.querySelector('select'); if(!l||!sel) return;
      var v=sel.value; var cm=/^\d+(\.\d+)?cm$/.test(v)?({'18cm':'19cm','20cm':'21.5cm'}[v]||v):''; /* [sizes-27oct] real length with clasp */
      var ov=l.querySelector('.opt-val'); if(ov){ if(cm) ov.setAttribute('data-c2len',cm); else ov.removeAttribute('data-c2len'); }
      l.classList.toggle('c2-nopick', !v || v==='__pick');
      l.classList.toggle('c2-colon', !/:/.test(l.textContent));
    });
  }
  function texts(){
    var q=document.querySelector('.pdp .sibw-q'); if(q && q.textContent.trim()!=='Also available') q.textContent='Also available';
    document.querySelectorAll('.pdp .fit-btn').forEach(function(b){
      var t=b.querySelector('.fit-btn-l')||b; if(/find your size/i.test(t.textContent)) {
        var walker=document.createTreeWalker(t,NodeFilter.SHOW_TEXT,null,false), n; while((n=walker.nextNode())){ if(/find your size/i.test(n.nodeValue)) n.nodeValue=n.nodeValue.replace(/find your size/i,'Size Guide'); }
      }
    });
  }
  function pounds(root){
    /* [deskv3-4oct f] the main price keeps the live site's "£165.00"; only the button drops the pence */
    (root||document).querySelectorAll('.pdp [data-atc-price]').forEach(function(e){
      var w=document.createTreeWalker(e,NodeFilter.SHOW_TEXT,null,false), n;
      while((n=w.nextNode())){ if(/\.00\b/.test(n.nodeValue)) n.nodeValue=n.nodeValue.replace(/(\u00A3\s?[\d,]+)\.00\b/g,'$1'); }
    });
  }
  /* a size the product is not made in reads "(N/A)" in the theme; mark it so the button can say "Not available"
     rather than "Out of stock" (it was never stock) */
  function na(){ document.querySelectorAll('.pdp .opt-chip').forEach(function(c){
    var t=c.querySelector('.opt-chip-t'); var isNa=/\(N\/A\)/i.test(c.textContent) || c.hasAttribute('data-c2na') && t && !/\S/.test(t.textContent.replace(/[A-Z]{1,2}/,''));
    if(/\(N\/A\)/i.test(c.textContent)){ c.setAttribute('data-c2na',''); if(t) t.textContent=t.textContent.replace(/\s*\(N\/A\)\s*/i,''); }
  }); }
  /* the alternative-product card ends in a chevron, as in the owner's mockup */
  function chevron(){ var s=document.querySelector('.pdp a.sibw > svg'); if(s && !s.dataset.c2){ s.innerHTML='<path d="M9 6l6 6-6 6"/>'; s.setAttribute('fill','none'); s.setAttribute('stroke','currentColor'); s.setAttribute('stroke-width','1.5'); s.setAttribute('stroke-linecap','round'); s.setAttribute('stroke-linejoin','round'); s.dataset.c2='1'; } }
  /* the theme's variant script writes "Add to cart" once a size is picked; the page says "Add to bag" */
  function bagWord(){ document.querySelectorAll('.pdp .btn-atc, .pdp button[name="add"]').forEach(function(b){
    var w=document.createTreeWalker(b,NodeFilter.SHOW_TEXT,null,false), n; while((n=w.nextNode())){ if(/add to cart/i.test(n.nodeValue)) n.nodeValue=n.nodeValue.replace(/add to cart/i, function(m){ return m===m.toUpperCase()?'ADD TO BAG':'Add to bag'; }); }
  }); }
  function run(){ label(); texts(); pounds(); na(); bagWord(); chevron(); }
  function boot(){
    run();
    document.addEventListener('change', function(e){ if(e.target && e.target.closest && e.target.closest('.pdp')) setTimeout(run,0); }, true);
    document.addEventListener('click', function(e){ if(e.target && e.target.closest && e.target.closest('.pdp .opt-chip')) setTimeout(run,30); }, true);
    var mo=new MutationObserver(function(){ mo.disconnect(); pounds(); label(); bagWord(); na(); obs(); });
    function obs(){ document.querySelectorAll('.pdp .head-band .price, .pdp [data-atc-price], .pdp .opt-label, .pdp .btn-atc, .pdp button[name="add"], .pdp .opt-chips').forEach(function(e){ mo.observe(e,{childList:true,characterData:true,subtree:true}); }); }
    obs();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();

/* [r14-4oct] PHONES: the size ladder that used to replace the theme's size buttons is no longer in the theme, so
   phones were left with the bare dropdown. The theme's own buttons are shown again (CSS); this only tidies their
   wording ("S (N/A)" -> "S", marked unavailable) and keeps doing so when the theme redraws them. */
(function(){
  if(!window.matchMedia||!window.matchMedia('(max-width: 1000px)').matches) return;
  function na(){ document.querySelectorAll('.pdp .opt-chip').forEach(function(c){
    var t=c.querySelector('.opt-chip-t');
    if(/\(N\/A\)/i.test(c.textContent)){ c.setAttribute('data-c2na',''); if(t) t.textContent=t.textContent.replace(/\s*\(N\/A\)\s*/i,''); }
  }); }
  /* [r16-4oct] mark the button while it still says "Select your size", so CSS can set that wording lighter */
  function pickWord(){ document.querySelectorAll('.pdp .btn-atc, .pdp button[name="add"]').forEach(function(b){ b.classList.toggle('c2-pickword', /select your size/i.test(b.textContent)); }); }
  function boot(){ na(); pickWord();
    document.querySelectorAll('.pdp .opt-chips').forEach(function(w){ new MutationObserver(na).observe(w,{childList:true,subtree:true,characterData:true}); });
    document.querySelectorAll('.pdp .btn-atc, .pdp button[name="add"]').forEach(function(b){ new MutationObserver(pickWord).observe(b,{childList:true,subtree:true,characterData:true}); }); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
